export default __webpack_public_path__ + "static/media/S-045.fadb5c8c.png";